// extracted by mini-css-extract-plugin
export default {"container":"footer_container__URGOU","text":"footer_text__DFN0n"};